// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rtl[data-v-3e34b92e]{direction:rtl}.ltr[data-v-3e34b92e]{direction:ltr}.v-card[data-v-3e34b92e]{-webkit-transition:all .3s;transition:all .3s}.v-btn[data-v-3e34b92e]{margin:4px 0}", ""]);
// Exports
module.exports = exports;
